import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ComparatorDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ComparatorDataQuery = { __typename?: 'query_root', smartphoneFamilies?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponseCollection', data: Array<{ __typename?: 'SmartphoneFamilyEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string, model: string, description?: Types.Maybe<any> }> }> }> };


export const ComparatorDataDocument = gql`
    query comparatorData {
  smartphoneFamilies {
    data {
      attributes {
        slug
        model
        description
      }
    }
  }
}
    `;
export function useComparatorDataQuery(baseOptions?: Apollo.QueryHookOptions<ComparatorDataQuery, ComparatorDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparatorDataQuery, ComparatorDataQueryVariables>(ComparatorDataDocument, options);
      }
export function useComparatorDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparatorDataQuery, ComparatorDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparatorDataQuery, ComparatorDataQueryVariables>(ComparatorDataDocument, options);
        }
export type ComparatorDataQueryHookResult = ReturnType<typeof useComparatorDataQuery>;
export type ComparatorDataLazyQueryHookResult = ReturnType<typeof useComparatorDataLazyQuery>;
export type ComparatorDataQueryResult = Apollo.QueryResult<ComparatorDataQuery, ComparatorDataQueryVariables>;